module.exports = __webpack_public_path__ + "img/gamedevdisciplines00.05ca0a59.jpg";